import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { useTranslation } from '@common/hooks/useTranslation';
import { Field, TextArea } from '@components/FormElements';
import { CUSTOM_VIDEO_QUESTION_MAX_LENGTH } from '../../rules/customVideoQuestion';

type Props = {
  value?: string;
  label?: string | React.ReactNode;
  onChange: (key: string) => void;
  error?: string;
  disabled?: boolean;
};

export const CustomQuestionField = ({
  value,
  disabled,
  label,
  onChange,
  error
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-3 z-10 relative">
      <Field
        label={label || ''}
        message={
          error && (
            <div className="mt-sm">
              <ErrorMessage>{error}</ErrorMessage>
            </div>
          )
        }
      >
        <div className="mt-[-20px]">
          <TextArea
            testID="job-form-customVideoQuestions"
            lines={2}
            disabled={disabled}
            value={value}
            tone={error ? 'danger' : 'neutral'}
            onChange={onChange}
            charCountMax={CUSTOM_VIDEO_QUESTION_MAX_LENGTH}
          />
          <div className="text-sm text-neutral-500 font-light leading-sm mt-2">
            {t('postJobForm.helperText.customVideoQuestion')}
          </div>
        </div>
      </Field>
    </div>
  );
};
